import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';

import { ForgotPasswordDirective } from './forgot-password.directive';
import { LoginCardComponent } from './login-card.component';
import { LoginFormComponent } from './login-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatSelectModule
  ],
  declarations: [
    ForgotPasswordDirective,
    LoginCardComponent,
    LoginFormComponent
  ],
  exports: [ForgotPasswordDirective, LoginCardComponent, LoginFormComponent]
})
export class LoginModule {}
